// components/LiveClock.jsx
import React from "react";
import Clock from "react-live-clock";

const LiveClock = () => {
  return (
    <Clock
      format={"hh:mm:ss A"}
      ticking={true}      
    />
  );
};

export default LiveClock;
